<template>
<div>
  <div style="width: 60%;text-align: left;padding: 50px;margin-left:50px">
    <p>黑猫货态查询：<el-link href="https://www.t-cat.com.tw/Inquire/trace.aspx" target="_blank" type="primary">https://www.t-cat.com.tw/Inquire/trace.aspx</el-link></p>
    <p>新竹货态查询：<el-link href="https://www.hct.com.tw/Search/SearchGoods_n.aspx" target="_blank" type="primary">https://www.hct.com.tw/Search/SearchGoods_n.aspx</el-link></p>
    <p>通盈货态查询：<el-link href="https://www.tong-ying.com.tw" target="_blank" type="primary">https://www.tong-ying.com.tw</el-link></p>
    <p>大荣货态查询：<el-link href="https://www.kerrytj.com/zh/checking" target="_blank" type="primary">https://www.kerrytj.com/zh/checking</el-link></p>
    <p>东风货态查询：<el-link href="http://east-wind.com.tw" target="_blank" type="primary">http://east-wind.com.tw</el-link></p>
    <p>7-11货态查询：<el-link href="https://eservice.7-11.com.tw/E-Tracking/search.aspx" target="_blank" type="primary">https://eservice.7-11.com.tw/E-Tracking/search.aspx</el-link></p>
    <p>全家货态查询：<el-link href="https://fmec.famiport.com.tw/FP_Entrance/QueryBox" target="_blank" type="primary">https://fmec.famiport.com.tw/FP_Entrance/QueryBox</el-link></p>
    <p>OK货态查询：<el-link href="https://ecservice.okmart.com.tw/Tracking/Search" target="_blank" type="primary">https://ecservice.okmart.com.tw/Tracking/Search</el-link></p>
    <p>萊爾富货态查询：<el-link href="https://www.hilife.com.tw/shipment-status" target="_blank" type="primary">https://www.hilife.com.tw/shipment-status</el-link></p>
    <p>虾皮宅配货态查询：<el-link href="http://query2.e-can.com.tw/ECAN_APP/search.shtm" target="_blank" type="primary">http://query2.e-can.com.tw/ECAN_APP/search.shtm</el-link></p>
    <p>虾皮店到店货态查询：<el-link href="https://spx.tw/" target="_blank" type="primary">https://spx.tw/</el-link></p>
    <p>露天订单查询：<el-link href="https://b2b.cvs.com.tw/RutenOrderSearch/" target="_blank" type="primary">https://b2b.cvs.com.tw/RutenOrderSearch/</el-link></p>
    <p>7-11门市查询：<el-link href="https://emap.pcsc.com.tw/emap.aspx" target="_blank" type="primary">https://emap.pcsc.com.tw/emap.aspx</el-link></p>
    <p>全家门市查询：<el-link href="https://www.family.com.tw/marketing/inquiry.aspx" target="_blank" type="primary">https://www.family.com.tw/marketing/inquiry.aspx</el-link></p>
    <p>萊爾富门市查询：<el-link href="http://www.hilife.com.tw/storeInquiry_street.aspx" target="_blank" type="primary">http://www.hilife.com.tw/storeInquiry_street.aspx</el-link></p>
    <p>佳博打印机驱动：<el-button type="primary" plain size="mini" @click="jbDownload">下载驱动</el-button></p>
    <p>得力new系列：<el-button type="primary" plain size="mini" @click="dlDownloadNew">下载驱动</el-button></p>
    <p>得力不带new系列：<el-button type="primary" plain size="mini" @click="dlDownload">下载驱动</el-button></p>
    <!-- <p>快递单号自动获取插件：<el-button type="primary" plain size="mini" @click="chromeDownload">下载</el-button></p> -->
    <!-- <p>Google快捷采购插件：<el-link :href="pluginDownloadUrl" target="_blank" type="primary">下载</el-link></p> -->
    <p>顺运宝采购插件1.1.9（2026.10.21更新）：<el-link :href="pluginDownloadUrl1" target="_blank" type="primary">下载</el-link></p>
    <p>PDA APP（2026.07.18更新）：<el-link :href="pdaDownloadUrl" target="_blank" type="primary">下载</el-link></p>
    <!-- <p>PDA APP_手机提货（2026.01.14更新）：<el-link :href="pdaDownloadUrlPhone" target="_blank" type="primary">下载</el-link></p> -->
    <p>顺运宝PDF打印服务_cn(2025.01.02更新)：<el-link :href="pdfDownloadUrl" target="_blank" type="primary">下载</el-link></p>
    <p>顺运宝PDF打印服务_tw(2025.01.02更新)：<el-link :href="pdfDownloadUrlTw" target="_blank" type="primary">下载</el-link></p>
  </div>
</div>
</template> 

<script>

export default {
  name: 'dashboard',
  components: {
    
  },
  mounted:function(){
    
  },
  data(){
    return{
      // pluginDownloadUrl: this.$kit.api.chromeDownload+"?t="+new Date().getTime(),
      pluginDownloadUrl1: this.$kit.api.chromeDownload1+"?t="+new Date().getTime(),
      pdaDownloadUrl: this.$kit.api.pdaDownload+"?t="+new Date().getTime(),
      // pdaDownloadUrlPhone: this.$kit.api.pdaDownloadPhone+"?t="+new Date().getTime(),
      pdfDownloadUrl: this.$kit.api.pdfDownload+"?t="+new Date().getTime(),
      pdfDownloadUrlTw: this.$kit.api.pdfDownloadTw+"?t="+new Date().getTime(),
    }
  }, 
  computed: {
    isMinScreen: {  //是否小屏幕，浏览器
        get() {
          return this.$store.state.isMinScreen;
        }
    },
    docHeight: {  //表格的高度
        get() {
          var height =  this.$store.state.docHeight;
          return height - 320;
        }
    },
        routeTab: {
            get(){
                try{
                    return this.$store.state.activeMenus[this.$route.path]
                }catch{
                    return null;
                }
            }
        }
  },
  methods: {
      jbDownload(){
          window.open(this.$kit.api.jbDownload,"_blank")
        },
      dlDownload(){
          window.open(this.$kit.api.dlDownload,"_blank")
      },
      dlDownloadNew(){
          window.open(this.$kit.api.dlDownloadNew,"_blank")
      },
      chromeDownload(){
        window.open(this.$kit.api.chromeDownload,"_blank")
      },
  }
}
</script>

<style scoped lang="scss">

</style>
